import React from 'react'
import classnames from 'classnames/bind'
import type { ShallowTaskWorkflowMilestone } from '@adc/sdk/types'
import { formatDate } from '../../utils/formatters'
import Text from '../elementals/text'
// @ts-ignore
import styles from './styles.scss'

const cx = classnames.bind(styles)

export const OFFER_DATE_FORMAT = 'M/D/YY'

interface MilestoneDateProps {
  milestone: ShallowTaskWorkflowMilestone
}

const MilestoneDate: React.FC<MilestoneDateProps> = ({ milestone }) => {
  if (milestone.completed_date) {
    return (
      <Text size='small' className={cx('milestone-date')}>
        Completed: {formatDate(milestone.completed_date, OFFER_DATE_FORMAT)}
      </Text>
    )
  }

  if (milestone.expected_completion_date) {
    return (
      <Text size='small' className={cx('milestone-date')}>
        Expected Completion:{' '}
        {formatDate(milestone.expected_completion_date, OFFER_DATE_FORMAT)}
      </Text>
    )
  }

  if (milestone.last_updated_date) {
    return (
      <Text size='small' className={cx('milestone-date')}>
        Updated: {formatDate(milestone.last_updated_date, OFFER_DATE_FORMAT)}
      </Text>
    )
  }

  return null
}

export default MilestoneDate
